jQuery( function( $ ) {
    "use strict"

    var accountMenu = function() {
        $( '<select />' ).appendTo( '.woocommerce-MyAccount-navigation' ).addClass( 'wc-account-select' );

        $( '<option />', {
            'value'   : '',
            'text'    : 'Navigate Your Account'
        } ).appendTo( '.wc-account-select' );

        $( '.woocommerce-MyAccount-navigation li a' ).each(function() {
            var el = $( this );

            $( '<option />', {
                'value'   : el.attr( 'href' ),
                'text'    : el.text()
            } ).appendTo( '.wc-account-select' );
        } );

        $( '.wc-account-select' ).on( 'change', function() {
            var option_val = $( this ).find( 'option:selected' ).val();

            if ( option_val != '' ) {
                window.location.href = option_val;
            }
        } );

        if ( $( '.wc-account-select option[value="' + window.location.href + '"]' ).length != 0 ) {
            $( '.wc-account-select' ).val( window.location.href );
        }
    }
    accountMenu();

} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-account.js